import { AxiosError, AxiosResponse } from "axios"
import { ApiError } from "../models/api_error"
import { isBaseError } from "./base_error";

/**
 * handleAxiosResponse
 */

export function handleAxiosResponse<T>(response: AxiosResponse<T | ApiError>): T {
  if (!response) {
    throw new ApiError(500, "Ocorreu um erro inesperado.");
  }

  if (response instanceof AxiosError) {
    throw new Error(response.message);
  }

  if (response.status !== 200 && response.status !== 202) {
    if (typeof response.data === 'string') {
      const err = JSON.parse(response.data);
      if (isBaseError(err)) {
        throw err;
      }
    } else if (typeof response.data === 'object') {
      if (isBaseError(response.data)) {
        throw response.data;
      }
      else if (response.data instanceof Blob) {
        throw response.data;
      }
    }
    const err = response.data as ApiError;
    throw new Error(err.Message);
  }

  return response.data as T;
}

/**
 * handleAxiosResponse
 */

export function handleAxiosBlobResponse(response: AxiosResponse<any | ApiError>): Blob {
  if (!response) {
    throw new ApiError(500, "Ocorreu um erro inesperado.");
  }

  if (response instanceof AxiosError) {
    throw new Error(response.message);
  }

  if (response.status !== 200 && response.status !== 202) {
    if (typeof response.data === 'string') {
      const err = JSON.parse(response.data);
      if (isBaseError(err)) {
        throw err;
      }
    } else if (typeof response.data === 'object') {
      if (isBaseError(response.data)) {
        throw response.data;
      }
    }
    const err = response.data as ApiError;
    throw new Error(err.Message);
  }

  return new Blob([response.data]) as Blob;
}
